import type { ICEFRLevel } from '@repo/config';
import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetGrammarCheckpointV1Response } from './get-grammar-checkpoint-v1-response';
import { getGrammarCheckpointV1ResponseSchema } from './get-grammar-checkpoint-v1-response';

export async function getGrammarCheckpointV1Api(
  level: ICEFRLevel,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetGrammarCheckpointV1Response>> {
  return getRequest<IGetGrammarCheckpointV1Response>({
    path: `/grammar/checkpoint/${level}/v1`,
    schema: getGrammarCheckpointV1ResponseSchema,
    options,
  });
}
